import { useTranslation } from 'react-i18next'
import { Button, Text, makeStyles, tokens } from '@fluentui/react-components'
import { useAuth } from '../auth/useAuth'

const useStyles = makeStyles({
  root: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colorNeutralBackground2,
  },
  card: {
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusXLarge,
    padding: '48px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    boxShadow: tokens.shadow16,
    minWidth: '340px',
  },
})

export default function LoginPage() {
  const styles = useStyles()
  const { t } = useTranslation()
  const { login } = useAuth()

  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <img src="/logo-icon.svg" alt="People" width={64} height={64} />
        <Text size={700} weight="bold">{t('app.title')}</Text>
        <Button appearance="primary" size="large" onClick={login}>
          {t('auth.loginWith')}
        </Button>
      </div>
    </div>
  )
}
